<div class="col gap-4">
  <h3 class="text-center">Lūdzu, izvēlies autentifikācijas veidu:</h3>
  @for (flow of availableFlows; track $index) {
    <div class="row align-items-center justify-content-between p-2 border-wrapper pointer" (click)="selectFlow(flow)">
      <h3 class="m-0">{{ flow.title }}</h3>
      <img [src]="flow.imgLocation" class="w-40">
    </div>
  }
  <h4 class="text-center"><a class="unstyled-link" href="https://www.eparaksts.lv/lv/palidziba" target="_blank">Nepieciešama palīdzība?</a></h4>
</div>
